import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/cases")({
  loader: () => ({ crumb: "Cases" }),
  component: () => <Outlet />
})
